import { ComponentPropsWithoutRef, ReactNode } from 'react';

import { UseQueryResult } from '@tanstack/react-query';

import classNames from 'classnames';

import QueryState from '@store:web/components/common/QueryState/QueryState';

export const REWARD_POOL_REQUIREMENTS_ANCHOR_ID = 'reward-pool-requirements';

type Props = ComponentPropsWithoutRef<'ul'> & {
  hasBorders?: boolean;
  children: ReactNode;
  query: UseQueryResult;
  isEmpty: boolean;
};

export const List = ({ children, isEmpty, query, hasBorders = true, ...props }: Props) => {
  return (
    <ul
      className={classNames(
        'flex flex-col',
        hasBorders && 'border-t border-b border-base-border-medium',
      )}
      style={{ scrollMarginTop: '250px' }}
      data-qa="requirements_list"
      id={REWARD_POOL_REQUIREMENTS_ANCHOR_ID}
      {...props}
    >
      {children}
      <QueryState
        isEmpty={isEmpty}
        query={query}
        loading={
          <div className="flex flex-col gap-6 py-6">
            {Array.from({ length: 4 }, (_, i) => {
              return <div key={i} className="skeleton-block h-10 lg:h-11" />;
            })}
          </div>
        }
      />
    </ul>
  );
};
